import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { sanitizeDialogSearch } from "@/lib/use-dialog-search";
import { appRoute } from "./route";

const ProjectsPage = lazy(async () => {
  const m = await import("@/features/projects/components/projects-page");
  return { default: m.ProjectsPage };
});

function ProjectsPageWrapper() {
  return (
    <Suspense fallback={null}>
      <ProjectsPage />
    </Suspense>
  );
}

export const projectsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/projects",
  // Addressable create/edit dialogs: `?new=1` / `?edit=<projectId>`.
  validateSearch: sanitizeDialogSearch,
  component: ProjectsPageWrapper,
});
